import { Pipe, PipeTransform } from '@angular/core';

import { footerTranslations } from '@usheru-hff/sdk/localization-keys';
import { rt } from '@usheru-hff/sdk/utils';

@Pipe({
  name: 'footerLocalize',
  standalone: true,
  pure: true
})
export class FooterLocalizePipe implements PipeTransform {
  transform(key: string, placeholder?: string): string {
    const value = rt('title', key, footerTranslations, placeholder);
    return value;
  }
}
